import { useEffect, useState } from "react";
import { CalendarDays } from "lucide-react";
import { api, daysAgo, today, fmtDate } from "@/lib/api";
import { Segment } from "./kit";
import { Screen, Card, Empty, Chip, rs } from "./ui";
import { TxnRow } from "./Home";
import { Slip } from "./Slip";

const SVC = [["", "All"], ["Payout", "Move to Bank"], ["Mobile Recharge,DTH", "Recharge"], ["BBPS", "Bill Pay"], ["Credit Card Bill", "Credit Card"], ["DMT", "DMT"],
  ["AEPS Cash Withdrawal,AEPS Balance Enquiry,AEPS Mini Statement,Aadhaar Pay", "AEPS"], ["Cash Deposit", "Cash Deposit"]];

const ST = [["", "All"], ["SUCCESS", "Successful"], ["PENDING", "Pending"], ["FAILED", "Failed"]];

export function MReports() {
  const [tab, setTab] = useState("txns");
  const [f, setF] = useState({ date_from: daysAgo(7), date_to: today() });
  const [svc, setSvc] = useState("");
  const [st, setSt] = useState("");
  const [rows, setRows] = useState(null);
  const [slip, setSlip] = useState(null);
  useEffect(() => {
    setRows(null);
    const req = tab === "ledger" ? api.get("/ledger", { params: f }) : tab === "commission" ? api.get("/commission/summary", { params: f }) : api.get("/transactions", { params: { ...f, service: svc || undefined } });
    req.then(({ data }) => setRows(data)).catch(() => setRows([]));
  }, [tab, f, svc]);
  const update = (t) => setRows((x) => x.map((r) => (r.txn_id === t.txn_id ? t : r)));
  const txns = tab === "txns" ? rows || [] : [];
  const cnt = (s) => txns.filter((t) => (s === "FAILED" ? ["FAILED", "REFUNDED"].includes(t.status) : t.status === s)).length;
  const shown = txns.filter((t) => !st || (st === "FAILED" ? ["FAILED", "REFUNDED"].includes(t.status) : t.status === st));
  const total = txns.filter((t) => t.status === "SUCCESS").reduce((a, t) => a + t.amount, 0);
  return (
    <Screen title="Reports" back={false} testid="m-reports">
      <div className="mb-3 flex items-center gap-2 rounded-xl border border-slate-200 px-3 py-2" data-testid="m-rep-dates">
        <CalendarDays className="h-5 w-5 text-slate-500" />
        <input type="date" className="min-w-0 flex-1 bg-transparent text-sm outline-none" value={f.date_from} onChange={(e) => setF({ ...f, date_from: e.target.value })} data-testid="m-rep-from" />
        <span className="text-slate-400">–</span>
        <input type="date" className="min-w-0 flex-1 bg-transparent text-sm outline-none" value={f.date_to} onChange={(e) => setF({ ...f, date_to: e.target.value })} data-testid="m-rep-to" />
      </div>
      <Segment items={[["txns", "Transactions"], ["ledger", "Ledger"], ["commission", "Commission"]]} value={tab} onChange={setTab} testid="m-rep-tab" />
      {tab === "txns" && (
        <>
          <div className="mt-3 grid grid-cols-2 gap-2" data-testid="m-rep-summary">
            {[["₹", rs(total), "Total (successful)", "text-[#0F2C47]"], ["●", cnt("SUCCESS"), "Successful", "text-emerald-500"], ["●", cnt("PENDING"), "Pending", "text-[#F26B1D]"], ["●", cnt("FAILED"), "Failed", "text-red-500"]].map(([i, v, l, c]) => (
              <div key={l} className="flex items-center gap-2 rounded-xl border border-slate-200 p-3"><span className={`text-lg font-bold ${c}`}>{i}</span><div><div className="font-display text-lg font-bold leading-tight">{v}</div><div className="text-[11px] text-slate-500">{l}</div></div></div>
            ))}
          </div>
          <div className="mt-3 grid grid-cols-4 gap-1" data-testid="m-rep-status">
            {ST.map(([v, l]) => <button key={v} onClick={() => setSt(v)} className={`h-8 rounded-full text-xs font-semibold ${st === v ? "bg-[#F26B1D] text-white" : "bg-slate-100 text-slate-600"}`} data-testid={`m-rep-st-${v || "all"}`}>{l}</button>)}
          </div>
          <div className="no-scrollbar -mx-4 mt-2 flex gap-2 overflow-x-auto px-4">
            {SVC.map(([v, l]) => <button key={v} onClick={() => setSvc(v)} className={`h-7 shrink-0 rounded-full border px-3 text-[11px] font-bold ${svc === v ? "border-[#0F2C47] text-[#0F2C47]" : "border-slate-200 text-slate-500"}`} data-testid={`m-rep-svc-${l.toLowerCase().replace(/\s+/g, "-")}`}>{l}</button>)}
          </div>
        </>
      )}
      <div className="mt-2" data-testid="m-rep-list">
        {rows === null ? <div className="py-10 text-center text-sm text-slate-400">Loading…</div> : (tab === "txns" ? !shown.length : !rows.length) ? <Empty text="Nothing in this date range" /> : (
          <>
            {tab === "txns" && shown.map((t) => <TxnRow key={t.txn_id} t={t} onClick={setSlip} />)}
            {tab === "ledger" && rows.map((e) => (
              <div key={e.id} className="flex items-center justify-between border-b border-slate-100 py-3 last:border-0" data-testid="m-ledger-row">
                <div className="min-w-0"><div className="truncate text-sm font-semibold">{e.description}</div><div className="text-xs text-slate-500">{fmtDate(e.created_at)} · {e.wallet.toUpperCase()}</div></div>
                <div className="text-right"><div className={`text-sm font-bold ${e.type === "CR" ? "text-emerald-600" : "text-red-600"}`}>{e.type === "CR" ? "+" : "-"} {rs(e.amount)}</div><div className="text-[11px] text-slate-400">Bal {rs(e.closing)}</div></div>
              </div>
            ))}
            {tab === "commission" && rows.map((c) => (
              <div key={c.service} className="flex items-center justify-between border-b border-slate-100 py-3 last:border-0" data-testid={`m-comm-${c.service}`}>
                <div><div className="text-sm font-semibold">{c.service}</div><div className="text-xs text-slate-500">{c.count} txns · {rs(c.amount)}</div></div>
                <div className="text-right text-sm"><div className="font-bold text-emerald-600">{rs(c.commission)}</div><div className="text-[11px] text-slate-400">TDS {rs(c.tds)}</div></div>
              </div>
            ))}
          </>
        )}
      </div>
      {slip && <Slip txn={slip} onClose={() => setSlip(null)} onUpdate={update} />}
    </Screen>
  );
}

export function MNotifications() {
  const [d, setD] = useState(null);
  useEffect(() => { api.get("/notifications").then(({ data }) => { setD(data); if (data.unread) api.post("/notifications/read-all"); }); }, []);
  return (
    <Screen title="Notifications" testid="m-notifications">
      {d && !d.items.length && <Empty text="No notifications" />}
      <div className="space-y-2">
        {(d?.items || []).map((n) => (
          <Card key={n.id} className={!n.read ? "border-amber-200" : ""} data-testid="m-notif-item">
            <div className="flex items-start justify-between gap-2"><div className="text-sm font-bold">{n.title}</div>{n.kind && n.kind !== "info" && <Chip s={n.kind === "success" ? "SUCCESS" : n.kind === "error" ? "FAILED" : "PENDING"} />}</div>
            <div className="mt-1 text-sm text-slate-600">{n.message}</div>
            <div className="mt-1 text-[11px] text-slate-400">{fmtDate(n.created_at)}</div>
          </Card>
        ))}
      </div>
    </Screen>
  );
}
